import React from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import MainLayout from '../components/MainLayout';
import { DeliveryNeighborhoodReportPage } from '../pages/reports/DeliveryNeighborhoodReportPage';
import { DeliveryNeighborhoodReportPrintPage } from '../pages/reports/DeliveryNeighborhoodReportPrintPage';
import SalesReportPage from '../pages/reports/SalesReportPage';
import PaymentsReportPage from '../pages/reports/PaymentsReportPage';
import StockReportPage from '../pages/reports/StockReportPage';
import SalesReportPrintPage from '../pages/reports/SalesReportPrintPage';
import PaymentsReportPrintPage from '../pages/reports/PaymentsReportPrintPage';
import StockReportPrintPage from '../pages/reports/StockReportPrintPage';

export const reportRoutes: RouteObject[] = [
  {
    path: '/reports/deliveries-neighborhoods',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <MainLayout>
            <DeliveryNeighborhoodReportPage />
          </MainLayout>
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/deliveries-neighborhoods/print',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <DeliveryNeighborhoodReportPrintPage />
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/sales',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <MainLayout>
            <SalesReportPage />
          </MainLayout>
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/sales/print',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <SalesReportPrintPage />
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/payments',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <MainLayout>
            <PaymentsReportPage />
          </MainLayout>
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/payments/print',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <PaymentsReportPrintPage />
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/stock',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <MainLayout>
            <StockReportPage />
          </MainLayout>
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports/stock/print',
    element: (
      <ProtectedRoute requiredRole="ADMIN">
        <React.Suspense fallback={<div />}>
          <StockReportPrintPage />
        </React.Suspense>
      </ProtectedRoute>
    ),
  },
];

export default reportRoutes;
